import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d2078ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "result-test-component" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-info" }, " Selecione o resultado que apareceu no autoteste: ", -1))
const _hoisted_3 = { class: "result-container" }
const _hoisted_4 = { class: "img-container w-100 d-flex justify-content-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex justify-content-center" }
const _hoisted_7 = { class: "img-container w-100 d-flex justify-content-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "d-flex justify-content-center" }
const _hoisted_11 = { class: "error-info" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-span open-sans-font" }, " Campo de preenchimento obrigatório, selecione uma opção.", -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_box = _resolveComponent("alert-box")!
  const _component_floating_card = _resolveComponent("floating-card")!
  const _component_test_result_modal = _resolveComponent("test-result-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_floating_card, {
      ref: "base-modal",
      stepNumber: "4",
      stepTitle: _ctx.StepContent.title,
      nextButtonActive: _ctx.canJumpNext,
      onNextStep: _cache[2] || (_cache[2] = ($event: any) => (this.$emit('nextStep'))),
      onPreviousStep: _cache[3] || (_cache[3] = ($event: any) => (this.$emit('previousStep')))
    }, {
      content: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_alert_box, {
          class: "px-3 mt-8",
          info: "",
          stepContent: _ctx.StepContent,
          onClick: _ctx.showInfoModal
        }, null, 8, ["stepContent", "onClick"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            class: _normalizeClass(["custom-radio left-radio", { 'has-error': _ctx.hasError }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["option-result", {
                checked: _ctx.registerTestStore.resultTest == 'negative',
                'has-error': _ctx.hasError,
              }])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  class: "result-image",
                  src: _ctx.negativeResultImagePath,
                  alt: ""
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("input", {
                  class: "hide-radio",
                  name: "covid-result",
                  type: "radio",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setResultTest('negative')))
                }, null, 32),
                _createElementVNode("span", {
                  for: "negative-result",
                  class: _normalizeClass(["open-sans-font hide-radio", {
                    checked: _ctx.registerTestStore.resultTest == 'negative',
                  }])
                }, "Negativo", 2)
              ])
            ], 2)
          ], 2),
          _createElementVNode("label", {
            class: _normalizeClass(["custom-radio right-radio", { 'has-error': _ctx.hasError }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["option-result double-image", {
                checked: _ctx.registerTestStore.resultTest == 'positive',
                'has-error': _ctx.hasError,
              }])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  class: "result-image",
                  src: _ctx.positiveResultImagePath,
                  alt: ""
                }, null, 8, _hoisted_8),
                _createElementVNode("img", {
                  class: "result-image",
                  src: _ctx.positiveResultVariantImagePath,
                  alt: ""
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("input", {
                  name: "covid-result",
                  type: "radio",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setResultTest('positive')))
                }, null, 32),
                _createElementVNode("span", {
                  for: "negative-result",
                  class: _normalizeClass(["open-sans-font hide-radio", {
                    checked: _ctx.registerTestStore.resultTest == 'positive',
                  }])
                }, "Positivo", 2)
              ])
            ], 2)
          ], 2)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_11, _hoisted_13, 512), [
          [_vShow, _ctx.hasError]
        ])
      ]),
      _: 1
    }, 8, ["stepTitle", "nextButtonActive"]),
    _createVNode(_component_test_result_modal, {
      ref: "info-modal",
      isActive: true
    }, null, 512)
  ]))
}